import * as angular from 'angular';
import 'angular-cookies';
import '@uirouter/angularjs';
import { RejectType, Transition, TransitionService } from '@uirouter/angularjs';
import 'angular-sanitize';
import 'angular-spinner';
import 'styling/index.scss';
import 'angular-tooltips';
import 'common/source/config/angular-tooltips';
import * as NavigationStates from 'components/navigation/shared/states';
import * as uiMaskModuleName from 'angular-ui-mask';

import 'ng-dialog';

import { UsSpinnerService } from 'common/source/types/angular-spinner';

import * as customerPortalLayouts from 'layouts';

import * as customerPortalStates from 'states';

import * as customerPortalComponents from './components';
import * as customerPortalDirectives from './directives';
import * as customerPortalServices from 'services';
import * as customerPortalModals from './modals';
import { NavigationService } from 'services/navigation';
import { AnalyticsService } from 'common/source/services/analytics';
import { CurrentUserService } from 'services/currentUser';

import NgDialogConfig from 'common/source/config/ng-dialog';
import QProviderConfig from 'common/source/config/q-provider';
import UsSpinnerConfig from 'common/source/config/us-spinner';
import UIRouterConfig from 'config/router';
import { FlagshipService } from 'services/flagship';

const app = angular.module('customerPortal', [
    'ui.router',
    'ngSanitize',
    'ngCookies',
    'angularSpinner',
    '720kb.tooltips',
    'ngDialog',
    uiMaskModuleName,
    customerPortalModals.module.name,
    customerPortalDirectives.module.name,
    customerPortalComponents.module.name,
    customerPortalLayouts.module.name,
    customerPortalStates.module.name,
    customerPortalServices.module.name
]);

app.config(UIRouterConfig);
app.config(NgDialogConfig);
app.config(QProviderConfig);
app.config(UsSpinnerConfig);

const contentLoadingSpinnerKey = 'content-loading-spinner';

interface CustomerPortalControllerScope extends angular.IScope {
    claimsSref: string;
}

app.controller('customerPortalController', function(
    $scope: CustomerPortalControllerScope,
    $rootScope: angular.IRootScopeService,
    $transitions: TransitionService,
    usSpinnerService: UsSpinnerService,
    navigationService: NavigationService,
    analyticsService: AnalyticsService,
    currentUserService: CurrentUserService,
    flagshipService: FlagshipService,
    $stateParams: StateParams
) {
    'ngInject';

    $scope.claimsSref = NavigationStates.getClaimsSref($stateParams.policyIndex);

    $transitions.onExit({}, () => {
        currentUserService.clearCustomerPolicyInfosCache();
    });

    $transitions.onStart({}, (transition: Transition) => {

        window.scrollTo(0, 0);
        if (transition.to().resolve) {
            try {
                const uiView = document.querySelector('ui-view') as HTMLElement;
                uiView.innerHTML = ''; // clear the view during the transition
            } catch (e) {
                // this element may not exist in a testing context, so prevent errors there
            }

            usSpinnerService.spin(contentLoadingSpinnerKey);

            // set a timeout to transition to an error state, or at least stop spinning, if
            // the state transition takes more than 15 seconds,
            // and possibly have an error message element always present just like spinner
        }
    });

    $transitions.onSuccess({}, (transition: Transition) => {

        const transitionTo = transition.to();
        if (transitionTo.url && transitionTo.url.substr(0, 8) === '/policy/') {
            const params = transition.params();
            currentUserService.getCustomerPolicyInfoByIndex(params.policyIndex).then((policyInfo) => {
                analyticsService.track('Viewed policy page', {
                    page: transitionTo.name,
                    policy_number: policyInfo.policy_number
                });
            });
        }
        analyticsService.page();
        if (currentUserService.isLoggedIn()) {
            flagshipService.getCampaignsForStates();
            if (flagshipService.featureFlagStatus === 'FeatureFlagStatus:Ready') {
                usSpinnerService.stop(contentLoadingSpinnerKey);
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    usSpinnerService.stop(contentLoadingSpinnerKey);
                });
            }
        } else {
            usSpinnerService.stop(contentLoadingSpinnerKey);
        }
    });

    $transitions.onError({}, (transition: Transition) => {
        usSpinnerService.stop(contentLoadingSpinnerKey);

        if (transition.$from().name !== 'error') {
            if (transition.error().type === RejectType.ERROR) {
                if (currentUserService.isLoggedIn()) {
                    navigationService.toErrorPage();
                } else {
                    navigationService.toLoginPage();
                }
            }
        }
    });
});

export { app };
